import { __assign, __awaiter, __generator } from "tslib";
import { getEcommerceSettings } from '@wix/ambassador-ecom-v1-ecommerce-settings/http';
import { RequestedFields, } from '@wix/ambassador-ecom-v1-ecommerce-settings/types';
import { canBusinessShip, hasAdditionalFees, hasRequestedFieldError, hasValidationsInCart, } from './eCommerceSettingsService.utils';
import { SPECS } from '../../constants';
import { ViewerStorage } from '../viewer-storage/ViewerStorage';
var ECOMMERCE_SETTINGS_CACHE_KEY = 'SPI_CONFIG_PROPERTIES';
var EcommerceSettingsService = /** @class */ (function () {
    function EcommerceSettingsService(_a) {
        var context = _a.context, apis = _a.apis, platformServices = _a.platformServices;
        var _this = this;
        this.ecommerceSettingsRequest = function () {
            return _this.httpClient.request(getEcommerceSettings({
                fields: [
                    RequestedFields.ADDITIONAL_FEES_SERVICE_PLUGIN,
                    RequestedFields.VALIDATIONS_SERVICE_PLUGIN,
                    RequestedFields.TAX,
                    RequestedFields.CHECKOUT,
                    RequestedFields.BUSINESS_INFO,
                    RequestedFields.DELIVERY,
                    RequestedFields.PREMIUM_SITE,
                ],
            }));
        };
        this.apis = apis;
        this.siteStore = context.siteStore;
        this.ecommerceSettingsViewerStorage = new ViewerStorage({
            cacheKey: ECOMMERCE_SETTINGS_CACHE_KEY,
            storage: this.apis.storage,
            siteStore: this.siteStore,
        });
        this.httpClient = platformServices.essentials.httpClient;
        this.errorHandler = platformServices.essentials.errorHandler;
    }
    EcommerceSettingsService.prototype.init = function () {
        this.ecommerceSettingsPromise = this.getEcommerceSettingsFromServerOrCache();
        if (this.siteStore.experiments.enabled(SPECS.UseEcommerceSettingsDeliveryCountries)) {
            this.ecommerceSettingsPromise.catch(function () {
                //
            });
        }
    };
    EcommerceSettingsService.prototype.getEcommerceSettings = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        return __awaiter(this, void 0, void 0, function () {
            var useEcommerceSettingsDeliveryCountries, ecommerceSettingsResponse, error_1;
            return __generator(this, function (_s) {
                switch (_s.label) {
                    case 0:
                        if (!this.ecommerceSettingsPromise) {
                            this.ecommerceSettingsPromise = this.getEcommerceSettingsFromServerOrCache();
                        }
                        useEcommerceSettingsDeliveryCountries = this.siteStore.experiments.enabled(SPECS.UseEcommerceSettingsDeliveryCountries);
                        _s.label = 1;
                    case 1:
                        _s.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.ecommerceSettingsPromise];
                    case 2:
                        ecommerceSettingsResponse = _s.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _s.sent();
                        /* istanbul ignore next */
                        if (!useEcommerceSettingsDeliveryCountries) {
                            throw error_1;
                        }
                        ecommerceSettingsResponse = {
                            ecommerceSettings: undefined,
                            errors: [
                                { requestedField: RequestedFields.DELIVERY },
                                { requestedField: RequestedFields.ADDITIONAL_FEES_SERVICE_PLUGIN },
                                { requestedField: RequestedFields.VALIDATIONS_SERVICE_PLUGIN },
                                { requestedField: RequestedFields.BUSINESS_INFO },
                                { requestedField: RequestedFields.CHECKOUT },
                                { requestedField: RequestedFields.PREMIUM_SITE },
                                { requestedField: RequestedFields.TAX },
                            ],
                        };
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, {
                            hasAdditionalFees: hasAdditionalFees(ecommerceSettingsResponse),
                            hasValidationsInCart: hasValidationsInCart(ecommerceSettingsResponse),
                            isPremium: !useEcommerceSettingsDeliveryCountries ||
                                !hasRequestedFieldError(ecommerceSettingsResponse.errors, RequestedFields.PREMIUM_SITE)
                                ? Boolean((_a = ecommerceSettingsResponse.ecommerceSettings) === null || _a === void 0 ? void 0 : _a.premiumSite)
                                : true,
                            delivery: this.getDeliveryConfiguration(ecommerceSettingsResponse),
                            tax: {
                                taxIncludedInItemPrices: Boolean((_c = (_b = ecommerceSettingsResponse.ecommerceSettings) === null || _b === void 0 ? void 0 : _b.tax) === null || _c === void 0 ? void 0 : _c.taxIncludedInItemPrices),
                                configured: Boolean((_f = (_e = (_d = ecommerceSettingsResponse.ecommerceSettings) === null || _d === void 0 ? void 0 : _d.tax) === null || _e === void 0 ? void 0 : _e.configured) !== null && _f !== void 0 ? _f : true),
                            },
                            businessInfo: {
                                storeName: (_h = (_g = ecommerceSettingsResponse.ecommerceSettings) === null || _g === void 0 ? void 0 : _g.businessInfo) === null || _h === void 0 ? void 0 : _h.name,
                                logo: (_k = (_j = ecommerceSettingsResponse.ecommerceSettings) === null || _j === void 0 ? void 0 : _j.businessInfo) === null || _k === void 0 ? void 0 : _k.logo,
                            },
                            checkoutSettings: {
                                checkoutPolicies: __assign({}, (_m = (_l = ecommerceSettingsResponse.ecommerceSettings) === null || _l === void 0 ? void 0 : _l.checkout) === null || _m === void 0 ? void 0 : _m.checkoutPolicies),
                                checkoutFields: __assign({}, (_p = (_o = ecommerceSettingsResponse.ecommerceSettings) === null || _o === void 0 ? void 0 : _o.checkout) === null || _p === void 0 ? void 0 : _p.checkoutFields),
                                checkoutBrand: __assign({}, (_r = (_q = ecommerceSettingsResponse.ecommerceSettings) === null || _q === void 0 ? void 0 : _q.checkout) === null || _r === void 0 ? void 0 : _r.checkoutBrand),
                            },
                        }];
                }
            });
        });
    };
    EcommerceSettingsService.prototype.getDeliveryConfiguration = function (ecommerceSettingsResponse) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (!this.siteStore.experiments.enabled(SPECS.UseEcommerceSettingsDeliveryCountries)) {
            return {
                canBusinessShip: canBusinessShip(ecommerceSettingsResponse),
                destinationScope: (_b = (_a = ecommerceSettingsResponse.ecommerceSettings) === null || _a === void 0 ? void 0 : _a.delivery) === null || _b === void 0 ? void 0 : _b.destinationScope,
                destinations: (_e = (_d = (_c = ecommerceSettingsResponse.ecommerceSettings) === null || _c === void 0 ? void 0 : _c.delivery) === null || _d === void 0 ? void 0 : _d.destinations) !== null && _e !== void 0 ? _e : [],
                postalCodeRequired: Boolean((_g = (_f = ecommerceSettingsResponse.ecommerceSettings) === null || _f === void 0 ? void 0 : _f.delivery) === null || _g === void 0 ? void 0 : _g.postalCodeRequired),
            };
        }
        if (hasRequestedFieldError(ecommerceSettingsResponse.errors, RequestedFields.DELIVERY)) {
            return {
                countries: [],
                restOfWorld: { pickupOnly: false, postalCodeRequired: false },
            };
        }
        return {
            countries: (_j = (_h = ecommerceSettingsResponse.ecommerceSettings) === null || _h === void 0 ? void 0 : _h.delivery) === null || _j === void 0 ? void 0 : _j.countries,
            restOfWorld: (_l = (_k = ecommerceSettingsResponse.ecommerceSettings) === null || _k === void 0 ? void 0 : _k.delivery) === null || _l === void 0 ? void 0 : _l.restOfWorld,
        };
    };
    EcommerceSettingsService.prototype.getEcommerceSettingsFromServerOrCache = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cachedEcommerceSettings, ecommerceSettings;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cachedEcommerceSettings = this.ecommerceSettingsViewerStorage.get();
                        if (cachedEcommerceSettings) {
                            return [2 /*return*/, cachedEcommerceSettings];
                        }
                        return [4 /*yield*/, this.errorHandler.withErrorHandler(function () { return _this.ecommerceSettingsRequest(); }, { errorCodesMap: {} })];
                    case 1:
                        ecommerceSettings = (_a.sent()).data;
                        this.ecommerceSettingsViewerStorage.set(ecommerceSettings);
                        return [2 /*return*/, ecommerceSettings];
                }
            });
        });
    };
    return EcommerceSettingsService;
}());
export { EcommerceSettingsService };
//# sourceMappingURL=EcommerceSettingsService.js.map